module.exports = __webpack_public_path__ + "static/fonts/NanumSquareR.05c46ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareR.ttf
// module id = VEwG
// module chunks = 1